import type { FilterSelection } from 'src/components/price-list/types';
import type { IVariantValue } from '../../types';
import { compareVariants } from './group-size-variants';

const getSelectedSizesAsVariants = (
  variantGroup: IVariantValue[],
  selection?: FilterSelection
): IVariantValue[] => {
  const findSizeInVariantGroup = (size: string) => {
    return variantGroup.find(variant => variant.size === size);
  };
  const selectedSizes = selection?.filter(findSizeInVariantGroup) || [];
  return selectedSizes.map(size => findSizeInVariantGroup(size)!);
};

export const getSelectedAndFirstFewVariants = (
  variantGroup: IVariantValue[],
  showSelectAll: boolean,
  limit: number,
  selection?: FilterSelection
) => {
  const selectedVariants = getSelectedSizesAsVariants(variantGroup, selection);
  const numSelected = selectedVariants.length || 0;
  const extraButtons = showSelectAll ? 1 : 0;
  const numNonSelectedVariantsToKeep =
    Math.max(0, limit - numSelected) - extraButtons;

  const variantIsNotSelected = (variant: IVariantValue) =>
    !selectedVariants.find(
      selectedVariant => selectedVariant?.size === variant.size
    );

  const nonSelectedVariantsToKeep = variantGroup
    .filter(variantIsNotSelected)
    .slice(0, numNonSelectedVariantsToKeep);

  const result = selectedVariants.concat(nonSelectedVariantsToKeep);
  return result.sort(compareVariants);
};
